import { buildEqFilter, mergeFilters, type GridFilters } from '@/ui/composites/grid/gridFilters';

export const filterSupportedQueryFields = <TFilter extends { field: string }>(
  filters: readonly TFilter[],
  supportedFields: ReadonlySet<string> | readonly string[],
): TFilter[] => {
  const supportedFieldSet =
    supportedFields instanceof Set ? supportedFields : new Set<string>(supportedFields);
  return filters.filter((filter) => supportedFieldSet.has(filter.field));
};

export const mergeProjectFilters = (
  filters: GridFilters,
  projectId?: string | null,
): GridFilters => {
  const hasProjectFilter = filters.some((filter) => filter.field === 'projectId');
  const normalizedProjectId =
    typeof projectId === 'string' && projectId.trim().length > 0 ? projectId : null;
  const projectFilters =
    !hasProjectFilter && normalizedProjectId !== null
      ? buildEqFilter('projectId', normalizedProjectId)
      : [];
  return mergeFilters(projectFilters, filters);
};
